import { useCallback, useEffect, useState } from 'react';
import { fetchUnreadCount, SocialApiError } from '../socialApi';
import { Badge } from '../ui/Badge';
import { HopperIcon } from '../ui/icons/HopperIcon';

type NotificationBellProps = {
  authenticated: boolean;
  onOpen: () => void;
  className?: string;
  expanded?: boolean;
};

export function NotificationBell({ authenticated, onOpen, className = '', expanded = false }: NotificationBellProps) {
  const [count, setCount] = useState(0);

  const refresh = useCallback(() => {
    if (!authenticated) {
      setCount(0);
      return;
    }
    void fetchUnreadCount()
      .then((response) => setCount(response.unread_count))
      .catch((error: unknown) => {
        if (error instanceof SocialApiError && error.status === 401) setCount(0);
      });
  }, [authenticated]);

  useEffect(() => {
    refresh();
    const timer = window.setInterval(refresh, 60_000);
    window.addEventListener('hopper:notifications-updated', refresh);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener('hopper:notifications-updated', refresh);
    };
  }, [refresh]);

  return (
    <button
      className={`pulse-notification-bell ${className}`.trim()}
      type="button"
      aria-label="Уведомления"
      aria-expanded={expanded}
      onClick={onOpen}
    >
      <HopperIcon name="bell" size={22} />
      {count > 0 && <Badge tone="error" className="pulse-notification-bell__badge">{count > 99 ? '99+' : count}</Badge>}
    </button>
  );
}
